import React from 'react';

// PowerPoint's default text insets for an autoshape, at 96dpi:
// 0.1in left/right, 0.05in top/bottom.
const INSET_X = 9.6;
const INSET_Y = 4.8;

/**
 * The Quill host, positioned at the preset's text rectangle.
 *
 * Deliberately a single element with no wrapper. use-resizer resolves a drag
 * started on .ql-editor to target.parentElement, and derives its drag surface
 * from parentElement.parentElement — both assume this host is a direct child of
 * the shape container. Nesting it one level deeper strands the text away from
 * its shape on the first drag. position/left/top are set here rather than in
 * CSS for the same reason: use-resizer writes them onto this node directly, so
 * React has to own them.
 *
 * Replaces the old calculateTop/calculateLeft lookup table, which placed text
 * with per-shape magic percentages and a fixed 50% width. Vertical centring is
 * handled by the flex rules on .shapeText.ql-container in index.css, matching
 * PowerPoint's middle-centre anchor.
 */
const ShapeText = ({ shapeId, textRect, isEditing = false }) => (
  <div
    id={`quill${shapeId}`}
    className="shapeText"
    // While editing, keep pointer interactions from reaching the shape's drag
    // handler: use-resizer would resolve them to this host and give the text
    // its own selection box.
    onMouseDown={isEditing ? (e) => e.stopPropagation() : undefined}
    style={{
      position: 'absolute',
      left: textRect.x,
      top: textRect.y,
      width: Math.max(0, textRect.width),
      height: Math.max(0, textRect.height),
      padding: `${INSET_Y}px ${INSET_X}px`,
      boxSizing: 'border-box',
      backgroundColor: 'transparent',
      margin: 0,
      // Inert until edited, so a click lands on the shape's <svg> and resolves
      // to the shape container rather than to this host.
      pointerEvents: isEditing ? 'auto' : 'none',
    }}
  />
);

export default ShapeText;
